'use client';

import ReportsPage from './reports/page';

export default function Home() {
  return <ReportsPage />;
}
